import React from "react";
import i18n from "i18next";
import {Box, IconButton, Link, styled, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Language} from "@mui/icons-material";

const StyledHeader = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0 1px 20px 0px #b5b5b5',
    alignItems: 'center',
    padding: '12px',
    paddingLeft: '40px',
    paddingRight: '48px',
    [theme.breakpoints.up('xs')]: {
        padding: '10px',
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    [theme.breakpoints.up('md')]: {
        padding: '12px',
        paddingLeft: '40px',
        paddingRight: '48px',
    },
}));

const Logo = styled(Typography)(({theme}) => ({
    color: '#232323',
    fontWeight: 600,
    [theme.breakpoints.up('xs')]: {
        fontSize: 16,
    },
    [theme.breakpoints.up('md')]: {
        fontSize: 20,
    },
}));

const Header = ({scrollToSection}) => {
    const {t} = useTranslation();
    const handleLanguageChange = async () => {
        const newLang = i18n.language === 'ru' ? 'de' : 'ru';
        await i18n.changeLanguage(newLang);
        localStorage.setItem('lang', newLang);
    };

    const de = i18n.language === 'de';

    return (
        <StyledHeader>
            <Logo variant="h6">LEUCHTTURM</Logo>
            <Box display="flex" alignItems="center" gap={2}>
                <Link
                    sx={{fontSize: 16, fontWeight: 600, textDecoration: 'none', cursor: 'pointer'}}
                    color="#232323"
                    onClick={() => scrollToSection('location')}
                >
                    {t('contacts')}
                </Link>
                <IconButton onClick={handleLanguageChange}>
                    {
                        de ? (
                                <svg width="57" height="34" viewBox="0 0 57 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="55" height="32" rx="16" fill="white"/>
                                    <rect x="0.5" y="0.5" width="56" height="33" rx="16.5" stroke="#21262D"
                                          strokeOpacity="0.2"/>
                                    <g clipPath="url(#clip0_10_5754)">
                                        <path
                                            d="M17 31C24.732 31 31 24.732 31 17C31 9.26801 24.732 3 17 3C9.26801 3 3 9.26801 3 17C3 24.732 9.26801 31 17 31Z"
                                            fill="#FF0000"/>
                                        <path
                                            d="M17 3C11.0397 3 5.87269 6.74496 3.91406 12L30.0781 12C28.1194 6.74496 22.9602 3 17 3Z"
                                            fill="black"/>
                                        <path
                                            d="M17 31C22.9603 31 28.0781 27.5 30.0781 22L3.91797 22C5.8766 27.255 11.0397 31 17 31Z"
                                            fill="#FFB800"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_10_5754">
                                            <rect width="28" height="28" fill="white" transform="translate(3 3)"/>
                                        </clipPath>
                                    </defs>
                                </svg>

                            )
                            : (
                                <svg width="57" height="34" viewBox="0 0 57 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="55" height="32" rx="16" fill="white"/>
                                    <rect x="0.5" y="0.5" width="56" height="33" rx="16.5" stroke="#21262D"
                                          strokeOpacity="0.2"/>
                                    <g clipPath="url(#clip0_10_5754)">
                                        <path
                                            d="M40 31C47.732 31 54 24.732 54 17C54 9.26801 47.732 3 40 3C32.268 3 26 9.26801 26 17C26 24.732 32.268 31 40 31Z"
                                            fill="#0500FF"/>
                                        <path
                                            d="M40 3C34.0397 3 28.8727 6.74496 26.9141 12L53.0781 12C51.1194 6.74496 45.9602 3 40 3Z"
                                            fill="#E1E1E1"/>
                                        <path
                                            d="M40 31C45.9603 31 51.0781 27.5 53.0781 22L26.918 22C28.8766 27.255 34.0397 31 40 31Z"
                                            fill="#FF0000"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_10_5754">
                                            <rect width="28" height="28" fill="white" transform="translate(26 3)"/>
                                        </clipPath>
                                    </defs>
                                </svg>

                            )
                    }
                </IconButton>
            </Box>
        </StyledHeader>
    );
};

export default Header;
